/* eslint-disable no-restricted-syntax */
export const clearThree = (obj) => {
  while (obj.children.length > 0) {
    clearThree(obj.children[0]);
    obj.remove(obj.children[0]);
  }
  if (obj.geometry) obj.geometry.dispose();

  if (obj.material) {
    // in case of map, bumpMap, normalMap, envMap ...
    Object.keys(obj.material).forEach((prop) => {
      if (!obj.material[prop]) return;
      if (
        obj.material[prop] !== null &&
        typeof obj.material[prop].dispose === "function"
      )
        obj.material[prop].dispose();
    });
    obj.material.dispose();
  }
};

export const recenterScene = (camera) => {
  console.info("123 recenterscene", camera.position);
  // camera.position.set(camera.position.x, 1.5, camera.position.z);
  window.XR8.XrController.recenter();
};
export function remove() {}

const removeCanvasIfPresent = () => {
  if (document.getElementById("SCENEAR")) {
    const rendererDiv = document.getElementsByClassName("renderer")[0];
    rendererDiv.removeChild(document.getElementById("SCENEAR"));
  }
};

export function createWebGLContext(glAttribs) {
  glAttribs = glAttribs || { alpha: false };
  removeCanvasIfPresent();
  const canvas = document.createElement("canvas");
  canvas.id = "SCENEAR";
  canvas.classList.add("SCENE");
  document.getElementsByClassName("renderer")[0].appendChild(canvas);
  const webglCanvas = canvas;
  const contextTypes = glAttribs.webgl2
    ? ["webgl2"]
    : ["webgl2", "webgl", "experimental-webgl"];
  let context = null;

  for (const contextType of contextTypes) {
    context = webglCanvas.getContext(contextType, glAttribs);
    if (context) {
      break;
    }
  }

  if (!context) {
    const webglType = glAttribs.webgl2 ? "WebGL 2" : "WebGL";
    console.error(`This browser does not support ${webglType}.`);
    return null;
  }

  return context;
}
